var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0014 2.03804C17.1334 -0.773332 21.9734 -0.679999 24.9902 2.34315C28.0071 5.36629 28.1107 10.1827 25.3049 13.324L13.9999 24.6467L2.69525 13.324C-0.110521 10.1827 -0.00564098 5.35868 3.00989 2.34315C6.02884 -0.675799 10.8603 -0.777506 14.0014 2.03804ZM23.1027 4.2268C21.1039 2.22392 17.8769 2.14268 15.7827 4.02249L14.0026 5.62032L12.2215 4.02375C10.1214 2.14129 6.90016 2.22411 4.89551 4.22876C2.90919 6.21508 2.80947 9.3964 4.63999 11.4976L13.9999 20.8724L23.3602 11.4976C25.1914 9.3956 25.0921 6.22033 23.1027 4.2268Z",
    fill: "#990000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.2ad61209168ad8a383b7e0326395aac2.svg";
export { ForwardRef as ReactComponent };